var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.bdxStatusList.length)?_c('BaseButton',{attrs:{"loading":_vm.isSaving,"size":"sm"},on:{"click":_vm.handleSave}},[_vm._v("Save")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }